import { useContext, useEffect, useState } from 'react';
import { Input, Space, Table, message } from 'antd';
import moment from 'moment';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import constants from '../../constants/constants';
import WebLinks from '../../api/WebLinks';
import { GetCustomPriorityLevelIcons, GetMonthText, GetPriorityLevelColors } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';

const { Search } = Input;

const BudgetLogs = () => {

	const commonContext=useContext(CommonContext);
	const buyerId = commonContext.common.buyerId;
	const [budgetActivityLog, setBudgetActivityLog] = useState([]);
	const [loading,setloading]=useState(false);
	const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
	const [sortedValue, setSorterValue] = useState({
    columnKey: "",
    order: 'descend'
  });
	const [logsCount, setLogsCount] = useState(0);

	useEffect(()=>{
		BudgetActivityLogListFetch(currentPage, pageSize, "", sortedValue.columnKey, sortedValue.order === "ascend" ? false : true);
	},[]);

	//fetch priority activity logs for last 90 days 
	const BudgetActivityLogListFetch = async (currentPage, pazeSize, searchValue, sortColumn, isSortDesc) =>{	
		setloading(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetBudgetLogs+buyerId
		+"&limit=" + pazeSize + "&pageNo=" + currentPage + "&search=" + searchValue + "&sortBy=" + sortColumn + "&sortDesc=" + isSortDesc
		);
		if(!response.isCatch && response.resultObj && response.resultObj.statusCode === "2000"){
			setBudgetActivityLog(response.resultObj.data);
			setLogsCount(response.resultObj.getCount);
			setloading(false);
		}else{
      message.error(response?.resultObj?.message||constants.ERROR_MESSAGE);
			setloading(false);
    }
	};

	// Table start
	const budgetLogColumns = [
		{
			title: 'Buyer Name',
			dataIndex: 'buyerName',
			key: 'buyerName',
    	sorter: (a, b) => a.buyerName.localeCompare(b.buyerName)
		},
    {
			title: 'Supplier Name',
			dataIndex: 'supplierName',
			key: 'supplierName',
    	sorter: (a, b) => a.supplierName.localeCompare(b.supplierName)
		},
		{
			title: 'Budget',
			dataIndex: 'budget',
			key: 'budget',
		},
		{
			title: 'Month',
			dataIndex: 'month',
			key: 'month',
			render: (text)=>{
				 return<span>{GetMonthText(parseInt(text))}</span>
			}
		},
		{
			title: 'Year',
			dataIndex: 'year',
			key: 'year',
		},
		{
			title: 'Updated On',
			dataIndex: 'updatedOn',
			key: 'updatedOn',
			render: (updatedOn)=>{
				return updatedOn?moment(updatedOn)?.format('YYYY-MM-D, h:mm a'):"";
			}
		},
		{
			title: 'Updated By',
			dataIndex: 'updatedByBuyerName',
			key: 'updatedByBuyerName',
			sorter: (a, b) => a?.updatedByBuyerName.localeCompare(b?.updatedByBuyerName)
		},
	];

	// Table pagination change
  const onChangeBudgetTable = (pagination, filters, sorter) => {
    if (pagination) {
      if (pageSize !== pagination.pageSize) {
        setCurrentPage(1);
      } else {
        setCurrentPage(pagination?.current);
      }
      setPageSize(pagination?.pageSize);
      if (sorter) {
        setSorterValue(sorter);
        BudgetActivityLogListFetch(pagination?.current, pagination?.pageSize, "", sorter.order ? sorter.columnKey : "", sorter.order === "ascend" ? false : true);
      } else {
        BudgetActivityLogListFetch(pagination?.current, pagination?.pageSize, "", sortedValue.columnKey, sortedValue.order === "ascend" ? false : true);
      }
    }
  };

	return (
		<div>
			<div className='uppercase font-bold text-xl'>Activity Logs - Budget</div>
			<div className='flex flex-wrap justify-between items-center gap-1 my-3'>
				<span className='text-slate-500'>{constants.BudgetLogLast90}</span>
				{/* <Search
					placeholder="Search"
					allowClear
					// onSearch={onSearch}
					enterButton
					className='w-60'
				/> */}
			</div>
			<div className='overflow-x-auto'>
				<Table 
					columns={budgetLogColumns} 
					dataSource={budgetActivityLog} 
					loading={loading}
					onChange={onChangeBudgetTable}
          pagination={{
            total: logsCount,
            showSizeChanger: true,
            pageSizeOptions: ["50", "100", "200", "500"],
            defaultPageSize: 100,
            current: currentPage,
          }}
          footer={() => budgetActivityLog.length>0?
             'Showing ' + ((currentPage - 1) * pageSize + 1) + ' to ' + ((currentPage - 1) * pageSize + budgetActivityLog?.length) + ' of ' + logsCount + ' entries'
            : 'Showing 0 entries'
          }
				/>
			</div>
		</div>
	);
};

export default BudgetLogs;